import Vue from 'vue'

export default class Model {
  constructor (data, included = null) {
    this._included = included || data.included
    const d = data.included ? data.data : data
    this._data = this._included ? this.format(d, this._included, 0) : d
  }

  format (data, included, idx = 0) {
    if (idx > 10) return
    for (let key in data.relationships) {
      if (Array.isArray(data.relationships[key].data)) {
        if (data.rel === undefined) data.rel = {}
        data.rel[key] = data.relationships[key].data.map((d) => {
          const relation = this.getRelationShipsIncluded(included, d)
          if (relation) {
            // return this.format(relation, included)
            try { return this.format(relation, included, idx + 1) } catch (e) { return null }
          } else { return null }
        })
      } else {
        const relation = this.getRelationShipsIncluded(included, data.relationships[key].data)
        if (relation) {
          if (data.rel === undefined) data.rel = {}
          // return this.format(relation, included)
          try { data.rel[key] = this.format(relation, included, idx + 1) } catch (e) {}
        }
      }
    }
    return data
  }

  getRelationShipsIncluded (included, data) {
    if (!data || !included) return null

    const r = included.filter((o) => {
      return o.id === data.id
    })
    return r ? r[0] : null
  }

  get (prop) {
    return Vue.$tools.getProp(this._data, prop)
  }

  has (prop) {
    return !!Vue.$tools.getProp(this._data, prop)
  }

  get id () {
    return this.get('id')
  }

  get uuid () {
    return this.get('attributes.uuid')
  }

  get url () {
    return Vue.$tools.getURL(this.get('attributes.path'))
  }
}
